import { render, staticRenderFns } from "./FloorPlanCanvas.vue?vue&type=template&id=4dbfb13a&scoped=true&"
import script from "./FloorPlanCanvas.vue?vue&type=script&lang=js&"
export * from "./FloorPlanCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FloorPlanCanvas.vue?vue&type=style&index=0&id=4dbfb13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbfb13a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VCardText,VChip})
